export const toTitleCase = (text: string): string => {
  if (!text) return "";
  return text
    .trim()
    .split(/\s+/) // Split by one or more whitespace characters
    .map((word) => {
      // Handle hyphenated words by capitalizing each part
      return word
        .split("-")
        .map(
          (part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase(),
        )
        .join("-");
    })
    .join(" ");
};

export const getFileNameWithoutExtension = (fileName: string): string => {
  if (!fileName) return "";
  const parts = fileName.split(".");
  return parts.length > 1 ? parts.slice(0, -1).join(".") : fileName;
};
